import React from 'react';
import { ArticleWithTableOfContentsSocialStack } from './TableOfContents.styles';
import Button from 'atoms/Button/Button';
import Link01 from 'app/icons/Monospaced/Link/Link01';
import Twitter from 'app/icons/Monospaced/SocialIcons/Twitter';
import Facebook from 'app/icons/Monospaced/SocialIcons/Facebook';
import LinkedIn from 'app/icons/Monospaced/SocialIcons/LinkedIn';

interface TableOfContentsSocialLinksProps {
  pathPrefix: string;
  slug: string;
  articleTitle: string;
}

const TableOfContentsSocialLinks = ({
  pathPrefix,
  slug,
  articleTitle,
}: TableOfContentsSocialLinksProps): JSX.Element => {
  return (
    <ArticleWithTableOfContentsSocialStack
      direction='row'
      gap='spacing-lg'
      align='flex-start'
      justify='flex-start'
      padding={['spacing-4xl', 'spacing-none', 'spacing-none']}
    >
      <Button
        size='md'
        href={`https://www.mightynetworks.com/${pathPrefix}/${slug}`}
        variant='secondary'
        className='social-button'
        decoration='none'
        iconPosition='left'
        icon={
          <Link01
            width={20}
            color='var(--fg-quaternary)'
          />
        }
      />
      <Button
        size='md'
        href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
          articleTitle
        )}&url=www.mightynetworks.com/${pathPrefix}/${slug}`}
        variant='secondary'
        className='social-button'
        decoration='none'
        iconPosition='left'
        icon={
          <Twitter
            width={20}
            color='var(--fg-quaternary)'
          />
        }
      />
      <Button
        size='md'
        href={`https://www.facebook.com/sharer/sharer.php?u=www.mightynetworks.com/${pathPrefix}/${slug}`}
        decoration='none'
        variant='secondary'
        className='social-button'
        iconPosition='left'
        icon={
          <Facebook
            width={20}
            color='var(--fg-quaternary)'
          />
        }
      />
      <Button
        size='md'
        href={`http://www.linkedin.com/shareArticle?mini=true&url=www.mightynetworks.com/${pathPrefix}/${slug}&title=${encodeURIComponent(
          articleTitle
        )}`}
        variant='secondary'
        className='social-button'
        decoration='none'
        iconPosition='left'
        icon={
          <LinkedIn
            width={20}
            color='var(--fg-quaternary)'
          />
        }
      />
    </ArticleWithTableOfContentsSocialStack>
  );
};

export default TableOfContentsSocialLinks;
